import React from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import {useNavigate} from 'react-router-dom'



const StaffTable = ({staffs, user}) => {
    const navigate = useNavigate()
  return (
    <TableContainer>
        <Table sx={{ minWidth: 350, }} aria-label="simple table">
            <TableHead>
            <TableRow>
                <TableCell sx={{color: 'var(--title-color) !important'}}>Name</TableCell>
                <TableCell sx={{color: 'var(--title-color) !important'}} align="right">Staff ID</TableCell>
                <TableCell sx={{color: 'var(--title-color) !important'}} align="right">Department</TableCell>
                <TableCell sx={{color: 'var(--title-color) !important'}} align="right">Role</TableCell>
                <TableCell sx={{color: 'var(--title-color) !important'}} align="right">Action</TableCell>
            </TableRow>
            </TableHead>
            <TableBody>
            {staffs?.slice(0, 5)?.map((item, i) => (
                item?._id !== user?._id && (
                    <TableRow
                    key={i}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 },  }}
                    >
                        <TableCell sx={{color: 'var(--title-color) !important'}} 
                        component="th" scope="row" >
                            {item?.firstName + ' ' + item?.lastName}
                        </TableCell>
                        <TableCell sx={{color: 'var(--title-color) !important'}} 
                        align="right">{item?.staffId}</TableCell>
                        <TableCell sx={{color: 'var(--title-color) !important'}} 
                        align="right">{item?.department}</TableCell>
                        <TableCell sx={{color: 'var(--title-color) !important'}} 
                        align="right">{item?.role}</TableCell>
                        <TableCell align="right">
                            <div className="home__content-table_div">
                                <button onClick={()=>navigate(`/chat_room/${item?._id}`)}
                                className="home__content-table_btn">
                                    <i class='bx bx-chat'></i>
                                </button>
                                <button onClick={()=>navigate('/email')}
                                className="home__content-table_btn">
                                    <i class='bx bx-envelope'></i>
                                </button>
                                <button onClick={()=>navigate(`/profile/${item?._id}`)}
                                className="home__content-table_btn">
                                    <i class='bx bx-show'></i>
                                </button>
                            </div>
                        </TableCell>
                    </TableRow>

                )
            ))}
            </TableBody>
        </Table>
    </TableContainer>
  )
}

export default StaffTable